<section>
    <div class="container">
        <ng-container *ngIf="loaded; else loadingContent">
            <div class="row align-items-center mb-3" *ngIf="statusCode == 0">
                <div class="col-auto">
                    <h3 class="heading">{{ "HOME.LATEST-NEWS" | translate }}</h3>
                </div>
                <div class="col-auto ml-auto">
                    <div class="see-more">
                        <a [routerLink]="['/news']"
                            >{{ "GENERAL.VIEW-MORE" | translate }} <fa-icon [icon]="icons.arrowRight"></fa-icon
                        ></a>
                    </div>
                </div>
            </div>
            <div *ngIf="registers" class="row">
                <ng-container>
                    <ng-container *ngTemplateOutlet="newsTemplate"></ng-container>
                </ng-container>
            </div>
        </ng-container>
    </div>
</section>

<ng-template #loadingContent>
    <div class="row mt-4">
        <div class="col-lg-6 mb-3">
            <ngx-skeleton height="200px"></ngx-skeleton>
        </div>
        <div class="col-lg-6 mb-3">
            <ngx-skeleton height="200px"></ngx-skeleton>
        </div>
        <div class="col-lg-6 mb-3">
            <ngx-skeleton height="200px"></ngx-skeleton>
        </div>
        <div class="col-lg-6 mb-3">
            <ngx-skeleton height="200px"></ngx-skeleton>
        </div>
    </div>
</ng-template>

<ng-template #newsSquared>
    <div class="col-lg-6 mb-4" *ngFor="let news of registers">
        <app-news-card
            [title]="news.sinopse.length > 140 ? (news.sinopse | slice : 0 : 140) + '[...]' : news.sinopse"
            [image]="!news.images ? './assets/images/unavailable.jpg' : news.images[0]['mini']"
            [date]="news.dt_post"
            [link]="'/news/' + news.url_amigavel"
            type="squared"
            [summary]="news.text_summary"
        ></app-news-card>
    </div>
</ng-template>

<ng-template #newsOblique>
    <div class="col-lg-6 mb-4" *ngFor="let news of registers">
        <app-news-card
            [title]="news.sinopse.length > 140 ? (news.sinopse | slice : 0 : 140) + '[...]' : news.sinopse"
            [image]="!news.images ? './assets/images/unavailable.jpg' : news.images[0]['mini']"
            [date]="news.dt_post"
            [link]="'/news/' + news.url_amigavel"
            [avatar]="news.url_avatar"
            type="oblique"
        ></app-news-card>
    </div>
</ng-template>

<ng-template #newsEye>
    <div class="col-lg-3 mb-4" *ngFor="let news of registers">
        <app-news-card-gnu
            [title]="news.sinopse.length > 70 ? (news.sinopse | slice : 0 : 70) + '[...]' : news.sinopse"
            [image]="!news.images ? './assets/images/unavailable.jpg' : news.images[0]['mini']"
            [date]="news.dt_post"
            [link]="'/news/' + news.url_amigavel"
        ></app-news-card-gnu>
    </div>
</ng-template>
